import React from 'react';
import {
  node,
  objectOf,
  string,
  number,
  oneOfType,
} from 'prop-types';
import { Grid } from '@material-ui/core';
import DefaultParagraph from '../../typeface/DefaultParagraph';
import variables from '../../styles/variables.module.scss';

const HeadlineSmall = ({
  children,
  className,
  style,
  color,
}) => (
  <Grid container alignItems="center" className={className} style={style}>
    <Grid item>
      <div
        style={{
          width: 27,
          marginRight: 3,
          height: 1,
          backgroundColor: color,
          marginBottom: 3,
        }}
      />
    </Grid>
    <Grid item>
      <DefaultParagraph
        xsmall
        style={{ color }}
      >
        {children}
      </DefaultParagraph>
    </Grid>
  </Grid>
);

HeadlineSmall.propTypes = {
  children: node,
  className: string,
  style: objectOf(oneOfType([
    string,
    number,
  ])),
  color: string,
};

HeadlineSmall.defaultProps = {
  children: null,
  className: null,
  style: null,
  color: variables.cleanWhite,
};

export default HeadlineSmall;
